import { DataTable } from '@/components/ui/data-table/data-table';
import { Skeleton } from '@/components/ui/skeleton';
import { useCategories } from '@/hooks/use-analytics-v2';
import { v2CategoriesColumns } from './categories-columns';

interface CategoriesSectionProps {
  fromDate: string;
  toDate: string;
  /** Account these metrics are scoped to. */
  accountId: number;
  /** Brand to scope to, or null for the whole account. */
  buId?: string | null;
}

/**
 * "Metrics by Category" section on the Ticket Metrics tab. Renders a table
 * with one row per category (Tickets / Avg AI Response /ticket / With AI /
 * Automated / Productivity). Backend handles sort (tickets descending), so
 * we just hand the rows to the DataTable as-is. Sorting is enabled in case
 * a user wants to flip by clicking a header.
 */
export function CategoriesSection({ fromDate, toDate, accountId, buId }: CategoriesSectionProps) {
  const { data, isLoading, isError } = useCategories(fromDate, toDate, accountId, undefined, buId);

  return (
    <div className='flex flex-col gap-3'>
      <h2 className='text-[12px] text-gray-800 font-medium'>Metrics by Category</h2>
      <div className='rounded-3xl border border-gray-300 bg-white p-2'>
        {isLoading ? (
          <div className='flex flex-col gap-2 p-4'>
            <Skeleton className='h-8 w-full rounded-md' />
            <Skeleton className='h-8 w-full rounded-md' />
            <Skeleton className='h-8 w-full rounded-md' />
            <Skeleton className='h-8 w-full rounded-md' />
          </div>
        ) : (
          <DataTable
            columns={v2CategoriesColumns}
            data={data ?? []}
            enableSorting
            enablePagination={false}
            emptyMessage={isError ? 'Failed to load categories.' : 'No categories in this range.'}
          />
        )}
      </div>
    </div>
  );
}
